import {
  FETCH_INVENTORY_REQUEST,
  FETCH_INVENTORY_SUCCESS,
  FETCH_INVENTORY_FAILURE,
  ADD_INVENTORY_SUCCESS,
  UPDATE_INVENTORY_SUCCESS,
  DELETE_INVENTORY_SUCCESS,
} from "./actions";
import { IInventory } from "../../services/inventoryApi";

interface InventoryState {
  items: IInventory[];
  totalCost: number;
  totalSellingPrice: number;
  loading: boolean;
  error: string | null;
}

const initialState: InventoryState = {
  items: [],
  totalCost: 0,
  totalSellingPrice: 0,
  loading: false,
  error: null,
};

export const inventoryReducer = (
  state = initialState,
  action: any
): InventoryState => {
  switch (action.type) {
    case FETCH_INVENTORY_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_INVENTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload.items,
        totalCost: action.payload.totalCost,
        totalSellingPrice: action.payload.totalSellingPrice,
      };

    case FETCH_INVENTORY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case ADD_INVENTORY_SUCCESS:
      return {
        ...state,
        items: [...state.items, action.payload],
        totalCost: state.totalCost + (action.payload.costPerUnit || 0),
        totalSellingPrice:
          state.totalSellingPrice + (action.payload.defaultSellingPrice || 0),
      };

    case UPDATE_INVENTORY_SUCCESS:
      return {
        ...state,
        items: state.items.map((item) =>
          item._id === action.payload._id ? action.payload : item
        ),
      };

    case DELETE_INVENTORY_SUCCESS:
      return {
        ...state,
        items: state.items.filter((item) => item._id !== action.payload),
      };

    default:
      return state;
  }
};
